import { Component } from '@angular/core';
import { TitleService } from '@src/app/core/services/title.service';
import { AuthService } from '@src/app/core/auth/auth.service';
import { getInitials } from '@src/app/core/helper/utils/utils';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent {
  constructor(public titleService: TitleService, private authService: AuthService) { }

  user: any = this.authService.getUserData();
  isDropdownOpen = false;
  nameInitials= this.user?.name ? getInitials(this.user.name) : '';
  logout(): void {
    this.authService.logout();
  }
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
